import * as React from 'react';
import '@progress/kendo-theme-bootstrap/dist/all.css';
import StringResourceManager, { GetString } from '../../StringResourceManager';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { createStyles, makeStyles } from '@material-ui/core';
import { Button } from '@progress/kendo-react-buttons';
import {
  DateTimePicker,
  DateTimePickerChangeEvent,
} from '@progress/kendo-react-dateinputs';
import { Error } from '@progress/kendo-react-labels';
import { getDateWithoutTimezone } from '../../../utils/utils';

const useStyles = makeStyles(theme =>
  createStyles({
    cancelButton: {
      width: '180px',
      border: '1px solid #000000',
    },
    buttonStyle: {
      alignItems: 'flex-end',
      marginTop: 33,
    },
    modalContainer: {
      display: 'flex',
      flexDirection: 'column',
    },
  })
);

interface Props {
  handleCloseDialog: (open: boolean) => void;
  processRequestCommand: (date: string, applyNow: boolean) => void;
}

const ApplyScheduleDatePickerDialog: React.FC<Props> = ({
  handleCloseDialog,
  processRequestCommand,
}): React.ReactElement => {
  const classes = useStyles();
  const YES = GetString('YES');
  const NO = GetString('NO');
  const INVALID_DATE_SCHEDULE = GetString('INVALID_DATE_SCHEDULE');

  const handleClose = () => {
    handleCloseDialog(false);
  };

  const [selectedScheduledDateTime, setSelectedScheduledDateTime] =
    React.useState<Date>(new Date());

  const handleConfirm = () => {
    processRequestCommand(
      new Date(selectedScheduledDateTime).toISOString(),
      false
    );
    handleCloseDialog(false);
  };

  const [isInvalidDate, setIsInvalidDate] = React.useState(true);
  const [errorMessage, setErrorMessage] = React.useState('');

  const dateSelectedOnChange = (e: DateTimePickerChangeEvent) => {
    if (!e.value) return;

    if (e.value < new Date()) {
      setIsInvalidDate(true);
      setErrorMessage(INVALID_DATE_SCHEDULE);
    } else {
      setSelectedScheduledDateTime(e.value);
      setIsInvalidDate(false);
      setErrorMessage('');
    }
  };

  return (
    <Dialog
      width="25vw"
      title={
        <StringResourceManager
          variant="body1"
          style="commandLabel"
          stringKey={'APPLY_SCHEDULE'}
          gutterBottom={true}
        />
      }
      onClose={handleClose}
    >
      <div className={classes.modalContainer}>
        <div style={{ marginBottom: '20px' }}>
          <StringResourceManager
            stringKey={'APPLY_CHANGES_CONFIRMATION_MESSAGE'}
          />
          <div>
            <DateTimePicker width={220} onChange={dateSelectedOnChange} />
            {isInvalidDate && <Error direction="start">{errorMessage}</Error>}
          </div>
          <br />
          {GetString('APPLY_SNAPSHOT_CONFIRM_MSG')}
        </div>
      </div>
      <DialogActionsBar>
        <Button onClick={handleConfirm} disabled={isInvalidDate}>
          {YES}
        </Button>
        <Button onClick={handleClose}>{NO}</Button>
      </DialogActionsBar>
    </Dialog>
  );
};

export default ApplyScheduleDatePickerDialog;
